(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var stored = localStorage.getItem('fiberwerx-vehicle');
    var vehicle = null;
    try { vehicle = stored ? JSON.parse(stored) : null; } catch (e) { vehicle = null; }

    /* ── Fitment bar ── */
    var bar = document.querySelector('.collection-fitment-bar');
    var toggle = bar ? bar.querySelector('.collection-fitment-bar__toggle input') : null;
    var vehicleLabel = bar ? bar.querySelector('.collection-fitment-bar__vehicle') : null;

    if (!vehicle || !vehicle.slug) return;

    var slug = 'fitment:' + vehicle.slug;

    /* ── Mark cards ── */
    var badges = document.querySelectorAll('.fits-badge');
    badges.forEach(function (badge) {
      var tags = badge.getAttribute('data-fitment-tags') || '';
      var card = badge.closest('.grid__item') || badge.closest('.card-wrapper');
      if (!card) return;

      if (tags.split(',').indexOf(slug) !== -1) {
        card.classList.add('card--fits');
      } else {
        card.classList.add('card--no-fit');
      }
    });

    /* ── Show fitment bar ── */
    if (bar) {
      vehicleLabel.textContent = vehicle.label;
      bar.style.display = '';

      /* Default: hide non-fitting */
      applyFilter(true);

      if (toggle) {
        toggle.addEventListener('change', function () {
          applyFilter(toggle.checked);
        });
      }
    }

    function applyFilter(onlyCompatible) {
      var noFitCards = document.querySelectorAll('.card--no-fit');
      noFitCards.forEach(function (card) {
        if (onlyCompatible) {
          card.classList.add('card--no-fit-hidden');
          card.classList.remove('card--no-fit-dimmed');
        } else {
          card.classList.remove('card--no-fit-hidden');
          card.classList.add('card--no-fit-dimmed');
        }
      });
    }
  });
})();
